<template>
  <div>
    <!-- Container -->
    <div class="w-11/12 mx-auto">
      <h2 class="big-title">
        Sales
      </h2>
      <!-- Container table -->
      <div class="form-container">
        <!-- Gradient Background -->
        <div class="gradient-background"></div>
        <!-- Title and search box -->
        <div class="relative z-10">
          <h3 class="form-title ">Orders</h3>

          <form class="md:flex md:w-7/12">
            <!-- Select Day -->
            <select
              name="selectedDay"
              v-model="selectedDay"
              class="input mb-8 md:mr-8"
            >
              <option
                v-for="day in days"
                :key="day.number"
                :value="day.number"
                >{{ day.name }}</option
              >
            </select>
            <!-- Select Type -->
            <select
              name="selectedType"
              v-model="selectedType"
              class="input mb-8"
            >
              <option
                v-for="type in types"
                :key="type.number"
                :value="type.name"
                :selected="type.name == 'All'"
                >{{ type.name }}</option
              >
            </select>
          </form>
          <div>
            <Button
              type="button"
              @click="refreshOrders"
              btnTitle="Refresh Orders"
              class="mr-4 mb-8 py-3 bg-exportBtn text-white w-44"
            />
            <Button
              type="button"
              @click="showAll"
              :btnTitle="`All orders (${this.data.length})`"
              class="mr-4 mb-8 py-3 bg-goldBeige text-black w-44"
            />
          </div>
        </div>
        <div class="w-full flex justify-center">
          <svg
            role="status"
            class="inline mr-2 w-10 h-10 text-gray-200 animate-spin dark:text-gray-600 fill-purple-600"
            viewBox="0 0 100 101"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            v-if="loading == true"
          >
            <path
              d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
              fill="currentColor"
            />
            <path
              d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
              fill="currentFill"
            />
          </svg>
        </div>
        <!-- Table -->
        <div class=" mt-10 text-sm xl:text-base">
          <table id="my-table" class="w-full">
            <tr class=" text-tableTitleColor text-left">
              <th class="pt-10">Id</th>
              <th class="pt-10">Client</th>
              <th class="pt-10">Time</th>
              <th class="pt-10">No. items</th>
            </tr>
            <tr
              v-for="order in this.filteredList"
              :key="order"
              class="border-b border-t border-tableBorderColor text-tableSubColor"
            >
              <td class=" px-2 py-2">{{ order.id }}</td>
              <td class=" px-2 py-2">{{ order.user_full_name }}</td>
              <td class=" px-2 py-2">{{ order.created_at }}</td>
              <td class=" px-2 py-2">{{ order.items_count }}</td>
              <td class="  text-center">
                <router-link
                  :to="{
                    name: 'OrdersId',
                    params: { id: order.id },
                  }"
                >
                  <font-awesome-icon
                    icon="eye"
                    class="text-sm xl:text-base mr-1 xl:mr-0 cursor-pointer"
                /></router-link>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Button from "../../components/Button.vue";
import { mapGetters, mapActions } from "vuex";
export default {
  name: "CurrentOrders",
  components: {
    Button,
  },
  data() {
    return {
      selectedDay: "",
      selectedType: "",
      types: [
        {
          number: "",
          name: "All",
        },
        {
          number: 1,
          name: "Take Away",
        },
        {
          number: 0,
          name: "Home Delivery",
        },
      ],
      currentSort: "name",
      currentSortDir: "asc",
      data: [],
      loading: null,
    };
  },

  computed: {
    ...mapGetters([
      "getOrders",
      "getUser",
      "getKitchenStaffOrders",
      "getDriversOrders",
    ]),
    ...mapActions(["fetchOrders"]),

    days() {
      const now = new Date();

      /* this.selectedDay = `${new Intl.DateTimeFormat("sv-SE", {
        year: "numeric",
      }).format(now)}-${new Intl.DateTimeFormat("sv-SE", {
        month: "2-digit",
      }).format(now)}-${new Intl.DateTimeFormat("sv-SE", {
        day: "2-digit",
      }).format(now)}`;
 */
      var startDate = now.setDate(now.getDate());
      const endDate = now.setDate(now.getDate() + 7); //after 7 days

      const dates = [];
      // Strip hours minutes seconds etc.
      let currentDate = new Date(
        new Date(startDate).getFullYear(),
        new Date(startDate).getMonth(),
        new Date(startDate).getDate()
      );

      while (currentDate <= new Date(endDate)) {
        const date = {
          number: `${new Intl.DateTimeFormat("sv-SE", {
            year: "numeric",
          }).format(currentDate)}-${new Intl.DateTimeFormat("sv-SE", {
            month: "2-digit",
          }).format(currentDate)}-${new Intl.DateTimeFormat("sv-SE", {
            day: "2-digit",
          }).format(currentDate)}`,
          name: `${this.capitalizeFirstLetter(
            new Intl.DateTimeFormat("sv-SE", { weekday: "long" }).format(
              currentDate
            )
          )} ${new Intl.DateTimeFormat("sv-SE", { day: "2-digit" }).format(
            currentDate
          )} ${this.capitalizeFirstLetter(
            new Intl.DateTimeFormat("sv-SE", { month: "long" }).format(
              currentDate
            )
          )} ${new Intl.DateTimeFormat("sv-SE", { year: "numeric" }).format(
            currentDate
          )}`,
        };

        dates.push(date);

        currentDate = new Date(
          currentDate.getFullYear(),
          currentDate.getMonth(),
          currentDate.getDate() + 1 // Will increase month if over range
        );
      }

      return dates;
    },

    filteredList() {
      // const users = this.getUsers.slice().reverse();

      if (this.selectedDay == "") {
        // console.log("null");
        return this.data;
      } else {
        // console.log("data");
        return this.data.filter((order) => {
          order.date_time_block.includes(this.selectedDay);
        });
      }
    },
  },

  async beforeMount() {
    // console.log(this.days[0].number);
    this.selectedDay = this.days[0].number;

    this.loading = true;
    await this.fetchOrders.then(async () => {
      this.data = await this.getOrders;
      this.loading = false;
    });
  },

  methods: {
    async showAll() {
      this.selectedDay = "";
    },

    refreshOrders() {
      this.$router.go();
    },

    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },

    sort(columnTitle) {
      // console.log("hello", columnTitle);
      //if columnTitle == current sort, reverse
      if (columnTitle === this.currentSort) {
        this.currentSortDir = this.currentSortDir === "asc" ? "desc" : "asc";
      }
      this.currentSort = columnTitle;
    },
  },
};
</script>
